var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarVoz2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#8894de;}.c{fill:#4132b4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z",
    transform: "translate(0 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11,21A10,10,0,0,1,1,11V1.667A.667.667,0,0,1,1.667,1H11a10,10,0,1,1,0,20Z",
    transform: "translate(1 -1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1.333,
    cy: 1.333,
    r: 1.333,
    transform: "translate(10.667 8.667)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1.333,
    cy: 1.333,
    r: 1.333,
    transform: "translate(14.667 8.667)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1.333,
    cy: 1.333,
    r: 1.333,
    transform: "translate(6.667 8.667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarVoz2);
export default __webpack_public_path__ + "static/media/dar-voz2.af458cbbba198ba546098f5217087c2d.svg";
export { ForwardRef as ReactComponent };